import { useAllParagraphs } from "./useAllParagraphs";

export type AttrRange = {
  value: any;
  start: number;
  end: number;
  length: number;
  textSnippet?: string;
  attributes?: Record<string, any>;
  paragraphIndex?: number;
};

const lengthOfOp = (op: any) => {
  const ins = op.insert;
  if (typeof ins === "string") return ins.length;
  if (ins && typeof ins === "object") return 1;
  return 0;
};

export const useAttributeInstances = (
  quill: any,
  quillDelta: any[],
  attribute: string
): AttrRange[] => {
  const ranges: AttrRange[] = [];
  let docIndex = 0;
  let current: AttrRange | null = null;

  const allParagraphs = useAllParagraphs(quill);

  for (const op of quillDelta) {
    const opLen = lengthOfOp(op);
    const hasAttr =
      op.attributes &&
      Object.prototype.hasOwnProperty.call(op.attributes, attribute);
    const value = hasAttr ? op.attributes[attribute] : undefined;

    if (hasAttr && opLen > 0) {
      if (current && current.value === value && current.end === docIndex) {
        current.end += opLen;
        current.length += opLen;
      } else {
        if (current) ranges.push(current);

        const paragraphBlot: any = quill.getLine(docIndex);
        let paragraphIndex: number | undefined = undefined;

        if (paragraphBlot?.[0]) {
          let line = paragraphBlot?.[0];

          let index = 0;
          for (const paragraph of allParagraphs) {
            if (paragraph.domNode == line.domNode) {
              paragraphIndex = index;
              break;
            }
            index++;
          }
        }

        current = {
          value,
          start: docIndex,
          end: docIndex + opLen,
          length: opLen,
          attributes: op.attributes ? { ...op.attributes } : undefined,
          paragraphIndex,
        };
      }
    } else {
      if (current) {
        ranges.push(current);
        current = null;
      }
    }

    docIndex += opLen;
  }

  if (current) ranges.push(current);

  for (const range of ranges) {
    const rangeText = quill.getText(range.start, range.length);
    range.textSnippet = rangeText;
  }

  return ranges;
};
